export enum ActionType
{
    UPDATE_AUTH,
}